import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteData, getData, getDataById, postData, postDataWithParams, updateData } from "../../../service/Service";

const initialState = {
  data: {
    docs: [],
  },
  updatedTime:0,
  isLoading: true,
  isError: "",
  message: "",
  postMessage: "",
  postStatus: "",
  deleteMessage: "",
  deleteStatus: "",
  updateMessage: "",
  updateStatus: "",
};

export const getDebtPlastic = createAsyncThunk(
  "farmer/debt-plastic",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getData("/farmer/debt-plastic", data.token, data.params);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getDebtPlasticById = createAsyncThunk(
  "farmer/debt-plastic/id",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getDataById("/farmer/debt-plastic/", data.token, data.id);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const sortDebtPlastic = createAsyncThunk(
  "farmer/debt-plastic/sort",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postDataWithParams(
        "/farmer/debt-plastic/search",
        data.token,
        data.body,
        data.params
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const postDebtPlastic = createAsyncThunk(
  "farmer/debt-plastic/post",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postData("/farmer/debt-plastic", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteDebtPlastic = createAsyncThunk(
  "farmer/debt-plastic/delete",
  async (data, { rejectWithValue }) => {
    try {
      const result = await deleteData("/farmer/debt-plastic/", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateDebtPlastic = createAsyncThunk(
  "farmer/debt-plastic/edit",
  async (data, { rejectWithValue }) => {
    try {
      const result = await updateData(
        "/farmer/debt-plastic/",
        data.token,
        data.id,
        data.value
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const debtPlasticSlice = createSlice({
  name: "Debt Plastic Store",
  initialState: initialState,
  reducers: {
    addDebtPlastic(state, action) {
      state.data.docs.unshift(action.payload);
    },
    sortDebtPlastic(state, action) {
      state.data.docs = action.payload;
    },
    deleteDebtPlastic(state, action) {
      state.data.docs = state.data.docs.filter(
        (item) => item._id !== action.payload
      );
    },
    editDebtPlastic(state, action) {
      let x = state.data.docs.findIndex((item) => item._id === action.payload._id);
      state.data.docs[x] = action.payload;
    },
  },
  extraReducers: {
    [getDebtPlastic.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getDebtPlastic.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.updatedTime = Date.now();
      state.message = action.payload.message;
    },
    [getDebtPlastic.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getDebtPlasticById.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getDebtPlasticById.fulfilled]: (state, action) => {
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getDebtPlasticById.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortDebtPlastic.pending]: (state, ) => {
      state.isLoading = true;
    },
    [sortDebtPlastic.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortDebtPlastic.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [postDebtPlastic.pending]: (state, ) => {
      state.isLoading = true;
    },
    [postDebtPlastic.fulfilled]: (state, action) => {
      state.postMessage = action.payload.message;
      state.postStatus = action.payload.status;
    },
    [postDebtPlastic.rejected]: (state, action) => {
      state.isError = true;
      state.postMessage = action.payload.message;
    },
    [deleteDebtPlastic.pending]: (state, ) => {
      state.isLoading = true;
    },
    [deleteDebtPlastic.fulfilled]: (state, action) => {
      state.deleteMessage = action.payload.message;
      state.deleteStatus = action.payload.status;
    },
    [deleteDebtPlastic.rejected]: (state, action) => {
      state.isError = true;
      state.deleteMessage = action.payload.message;
    },
    [updateDebtPlastic.pending]: (state, ) => {
      state.isLoading = true;
    },
    [updateDebtPlastic.fulfilled]: (state, action) => {
      state.updateMessage = action.payload.message;
      state.status = action.payload.status;
    },
    [updateDebtPlastic.rejected]: (state, action) => {
      state.isError = true;
      state.updateMessage = action.payload.message;
    },
  },
});

export const debtPlasticActions = debtPlasticSlice.actions;

export default debtPlasticSlice.reducer;
